export const OUTCOME_TYPES = {
  RETIREMENT: 'retirement',
  EMERGENCY_FUND: 'emergencyFund',
  PAY_OFF_DEBT: 'payOffDebt',
  GENERAL_SAVINGS: 'generalSavings',
  EDUCATION: 'education',
  LIFESTYLE: 'lifestyle',
};
